// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbj_a bhr_i bhr_j","ColorVariants__color":"bbj_b bhr_rp","ColorVariants__more":"bbj_c bhr_vv"};